export default __webpack_public_path__ + "static/media/Fire Icon.6435e5dc.svg";